<table [formGroup]="parentFormGroup" class="action-table">
  <thead>
    <tr>
      <th class="title"></th>
      <th class="title">Plano de Ação</th>
      <th class="text-center">Status</th>
      <th class="text-center">Término planejado</th>
      <th class="text-center">Término previsto</th>
      <th class="text-center"></th>
      <th class="text-center">Atualização</th>
      <th class="text-center"></th>
    </tr>
  </thead>
  <tbody [formArrayName]="formName">
    <ng-container *ngFor="let com of actions?.controls; let i = index"  [formGroupName]="i">
      <tr *ngIf="currentItem[i] as variable" [ngClass]="{'tr-disabled':!variable.meetingEnabled}" class="tr-{{i % 2}}">
        
        <td class="text-center">
          <input type="checkbox" class="ms-2" [checked]="variable?.checkeds" formControlName="checkeds"/>
        </td>
        <td>
          {{variable?.title}}
          <span *ngIf="variable?.pf_ind_action_manager_main?.tb_pss_pessoa?.str_nome" class="info-text">
            <div class="d-flex">
              <span class="icon-person font-icon icon-fill text-dark" alt="Exibir detalhes do usuário" title="Exibir detalhes do usuário"
                (click)="variable.show_resp = variable['show_resp'] != null? !variable['show_resp']:true">
                person
              </span>
              Resp.: {{variable?.pf_ind_action_manager_main?.tb_pss_pessoa?.str_nome}}
            </div>
            <span class="info-text" *ngIf="variable.show_resp">
              E-mail.: {{variable?.pf_ind_action_manager_main?.tb_pss_pessoa?.str_email_responsavel_projeto}}
              <br/>
              Telefone.: ({{variable?.pf_ind_action_manager_main?.tb_pss_pessoa?.num_ddd_1}}) {{variable?.pf_ind_action_manager_main?.tb_pss_pessoa?.num_telefone_1}}
            </span>
          </span>
          <span class="info-text" *ngIf="!variable.resp_nome">
            <br/>{{variable?.responsible}}
          </span>
          <span class="info-text" *ngIf="variable.lockdown_id">
            <br/>Solicitado nova informação em 
            {{variable.lockdown_dt | date: 'dd/MM/YYYY H:mm:s'}}
            <i class="icon-exclamation-sign" (click)="variable.show_managerInfo = true"></i>
            <span class="info-text" *ngIf="variable.show_managerInfo">
              <br/>Solicitante.: {{variable?.lockdown_resp}}
            </span>
          </span>
        </td>
        <td class="text-center">{{variable?.pf_ind_action_analysis_last?.action_status?.name ?? 'NA'}}</td>
        <td class="text-center">{{variable?.deadline | date: 'dd/MM/YYYY'}}</td>
        <td class="text-center">{{variable?.pf_ind_action_analysis_last?.deadline ?? variable?.deadline | date: 'dd/MM/YYYY'}}</td>
        <td class="text-center">
          <div class="dot dot-issue-{{variable?.pf_ind_action_analysis_last?.status1 ?? 0}}"></div>
          <strong class="text-danger" *ngIf="variable?.pf_ind_action_analysis_last?.diff_days">
            <br/>{{variable?.pf_ind_action_analysis_last?.diff_days*-1}}
          </strong>
        </td>
        <td class="text-center">
          {{variable?.pf_ind_action_analysis_last?.tb_pss_pessoa_ctr_atu?.str_nome}}
          <br/>{{variable?.ctr_dth_atu | date: 'dd/MM/YYYY'}}
        </td><td class="text-center">
          <span class="icon-table icon-button" *ngIf="variable?.description" (click)="variable['show_description'] = variable['show_description'] != null? !variable['show_description']:true">
            <img src="assets/images/svgs/lupa{{variable?.show_description?'-menos':''}}.svg" alt="Consultar" tooltip="Consultar" placement="bottom">
          </span>
        </td>
      </tr>
      <ng-container *ngIf="currentItem[i] as variable" >
        <tr *ngIf="variable?.show_description == true">
          <td colspan="8"  class="break-word td-description">
            <strong>Situação: </strong>
            {{variable?.description}}
          </td>
        </tr>
      </ng-container>
    </ng-container>
  </tbody>
</table> 